function safeSetLocalStorage (key, value) {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.setItem(key, value)
    }
  } catch (e) {
    // localStorage not available
  }
}

function safeGetLocalStorage (key) {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return window.localStorage.getItem(key)
    }
  } catch (e) {
    // localStorage not available
  }
  return null
}

function persistUTMParams () {
  const params = new URLSearchParams(window.location.search)
  const utm = {
    source: params.get('utm_source'),
    medium: params.get('utm_medium'),
    campaign: params.get('utm_campaign')
  }

  if (utm.source || utm.medium || utm.campaign) {
    safeSetLocalStorage('utm_params', JSON.stringify(utm))
    document.cookie = `utm_params=${encodeURIComponent(JSON.stringify(utm))};path=/;max-age=${60 * 60 * 24 * 90}`
  }
}

function getUTMParams () {
  const utm = safeGetLocalStorage('utm_params')
  if (utm) return JSON.parse(utm)

  const match = document.cookie.match(/utm_params=([^;]+)/)
  if (match) return JSON.parse(decodeURIComponent(match[1]))

  return undefined
}

export {
  persistUTMParams,
  getUTMParams,
  safeSetLocalStorage,
  safeGetLocalStorage
}
